import axios from '@/api/config';

const agentUserInfo = {

    pageList (data) {
        return axios.post(`${process.env.BASE_URL}/agentRoleInfo/pageList`, data);
    },
    addAgentRoleInfo (data) {
        return axios.post(`${process.env.BASE_URL}/agentRoleInfo/addAgentRoleInfo`, data);
    },
    updateAgentRoleInfo (data) {
        return axios.put(`${process.env.BASE_URL}/agentRoleInfo/updateAgentRoleInfo`, data);
    },
    deleteAgentRoleInfo (data) {
        return axios.delete(`${process.env.BASE_URL}/agentRoleInfo/deleteAgentRoleInfo`, { data: data });
    },
    getResourceTreeForAgent (data) {
        return axios.get(`${process.env.BASE_URL}/resource/getResourceTreeForAgent`, { params: data });
    },
    getAgentRoleInfoList (data) {
        return axios.get(`${process.env.BASE_URL}/agentRoleInfo/getAgentRoleInfoList`, { params: data });
    },
    getAgentRoleInfo (data) {
        return axios.get(`${process.env.BASE_URL}/agentRoleInfo/getAgentRoleInfo`, { params: data });
    },
    examStudent (data) {
        return axios.get(`${process.env.BASE_URL}/examStudent/reexamine`, { params: data });
    },

}

export default agentUserInfo;



// WEBPACK FOOTER //
// ./src/api/agentRoleInfo.js